const MehfoozExpress = () => {
    return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Mehfooz Express
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS Mehfooz Express is an overnight document delivery service, offered as a safer document dispatch option 
              to customers who might otherwise use the Express Flyer. The ‘Mehfooz’ envelope is a fortified, water, 
              temperature and tear-resistant, hard envelope especially designed for the safe transit of important documents. 
              The envelope is also laminated inside and outside, making it hard to bend. With an extra secure seal and 
              careful making, all possible efforts have been made to protect the valuables enclosed within.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/DomesticScrollingBanner/image8.jpg" alt="" className="rounded-md max-w-[100%] sm:mt-[0rem] mt-[1rem]"/>
          </div>
        </div>
      
      </div>
    </div>

    )
};
export default MehfoozExpress;